function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import useData from "./Components/PropertyResult/data";
import ListTitle from "../Components/ListTitle";
import PropertyMapView from "../Components/PropertyMapView";
import { toast } from "react-toastify";
import GMaps from "../Components/GMap";
import Container from "../Components/Container";
import AspectBanner from "../Components/AspectBanner";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ProjectsPage = function ProjectsPage(_ref) {
  var _config$projects;
  var projectsHeading = _ref.projectsHeading,
    paginationButtonClass = _ref.paginationButtonClass,
    propertyBackgroundColorWithOverlay = _ref.propertyBackgroundColorWithOverlay,
    ThemeProvider = _ref.ThemeProvider,
    theme = _ref.theme,
    isChristmasClient = _ref.isChristmasClient,
    config = _ref.config,
    ComponentsRenderer = _ref.ComponentsRenderer,
    winnreNoAuth = _ref.winnreNoAuth,
    appType = _ref.appType,
    onNavigateToDetail = _ref.onNavigateToDetail;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isMapView = _useState2[0],
    setIsMapView = _useState2[1];
  var _useData = useData({
      isMapView: isMapView,
      winnreNoAuth: winnreNoAuth
    }),
    projects = _useData.projects,
    loadingProjects = _useData.loadingProjects,
    totalPages = _useData.totalPages,
    currentPage = _useData.currentPage,
    setCurrentPage = _useData.setCurrentPage,
    addFilterHandlerNew = _useData.addFilterHandlerNew,
    resetFilters = _useData.resetFilters;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    mapViewActive = _useState4[0],
    setMapViewActive = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    markers = _useState6[0],
    setMarkers = _useState6[1];
  var _useState7 = useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    activeMarker = _useState8[0],
    setActiveMarker = _useState8[1];
  var _useState9 = useState(28.38),
    _useState0 = _slicedToArray(_useState9, 2),
    lngs = _useState0[0],
    setLngs = _useState0[1];
  var _useState1 = useState(77.12),
    _useState10 = _slicedToArray(_useState1, 2),
    lats = _useState10[0],
    setLats = _useState10[1];
  var viewMapHandler = function viewMapHandler(projectId) {
    var filt = markers.filter(function (mark) {
      return mark.id === projectId;
    });
    if (filt.length !== 0) {
      var _filt$, _filt$2;
      setActiveMarker(projectId);
      setLats(Number((_filt$ = filt[0]) === null || _filt$ === void 0 ? void 0 : _filt$.lat));
      setLngs(Number((_filt$2 = filt[0]) === null || _filt$2 === void 0 ? void 0 : _filt$2.lng));
      setMapViewActive(projectId);
    } else toast.error("Location not available");
  };
  useEffect(function () {
    var _marks;
    var marks = [];
    projects === null || projects === void 0 || projects.map(function (project) {
      var _project$projectLocat, _project$projectLocat2;
      marks = [].concat(_toConsumableArray(marks), [{
        id: project.id,
        name: project.projectName,
        price: project.price,
        city: project.city,
        lat: ((_project$projectLocat = project.projectLocation) === null || _project$projectLocat === void 0 ? void 0 : _project$projectLocat.latitude) || 0.0,
        lng: ((_project$projectLocat2 = project.projectLocation) === null || _project$projectLocat2 === void 0 ? void 0 : _project$projectLocat2.longitude) || 0.0
      }]);
    });
    if (((_marks = marks) === null || _marks === void 0 ? void 0 : _marks.length) === (projects === null || projects === void 0 ? void 0 : projects.length)) setMarkers(marks);
  }, [projects]);
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: theme,
    children: [(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 ? void 0 : _config$projects.backgroundImage) && /*#__PURE__*/_jsx(AspectBanner, {
      image: config === null || config === void 0 ? void 0 : config.projects.backgroundImage
    }), ComponentsRenderer && /*#__PURE__*/_jsx(ComponentsRenderer, {
      components: config === null || config === void 0 ? void 0 : config.projects.components
    }), /*#__PURE__*/_jsxs(Container, {
      className: "relative min-h-screen h-auto",
      config: config,
      children: [/*#__PURE__*/_jsx("div", {
        className: " z-40 px-2 lg:px-4 xl:px-12 2xl:px-20",
        id: "project_map_container",
        children: /*#__PURE__*/_jsx(ListTitle, {
          addFilterHandlerNew: addFilterHandlerNew,
          config: config,
          isMapView: isMapView,
          onMapClick: function onMapClick() {
            return setIsMapView(true);
          },
          onGridClick: function onGridClick() {
            return setIsMapView(false);
          },
          winnreNoAuth: winnreNoAuth,
          onResetFilters: resetFilters
        })
      }), /*#__PURE__*/_jsxs("div", {
        id: "project_section",
        className: "flex relative justify-between w-full pl-4 lg:pl-6 xl:pl-12 2xl:pl-20\n                \n                ",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "w-full lg:w-[50%] mt-7 mb-0 lg:my-5",
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-between",
            children: /*#__PURE__*/_jsxs("h2", {
              className: "".concat(config.fontBody, " mb-2"),
              children: [" ", projects === null || projects === void 0 ? void 0 : projects.length, " Projects listed here"]
            })
          }), /*#__PURE__*/_jsx(PropertyMapView, {
            projects: projects,
            loadingProjects: loadingProjects,
            totalPages: totalPages,
            projectsHeading: projectsHeading,
            currentPage: currentPage,
            onPageChange: setCurrentPage,
            propertyBackgroundColorWithOverlay: propertyBackgroundColorWithOverlay,
            paginationButtonClass: paginationButtonClass,
            viewMapHandler: viewMapHandler,
            mapViewActive: mapViewActive,
            isMapView: isMapView,
            theme: theme,
            config: config,
            winnreNoAuth: winnreNoAuth,
            appType: appType,
            onForceList: function onForceList() {
              return setIsMapView(false);
            },
            onNavigateToDetail: onNavigateToDetail
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "hidden lg:block z-20 ",
          children: /*#__PURE__*/_jsx(GMaps, {
            locations: markers,
            viewMapHandler: viewMapHandler,
            activeMarker: activeMarker,
            config: config,
            appType: appType
          })
        })]
      })]
    })]
  });
};
export default ProjectsPage;